export default "__VITE_ASSET__D_pFI5vO__"